import { useRef, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router-dom'
import cn from 'classnames'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import { analyticsContext, useValueContext } from 'contexts'
import { Button, Link, Slider, Tooltip } from 'components'

import { Step1, Step2 } from './settingsSteps'
import welcome1 from './img/welcome1.png'
import welcome2 from './img/welcome2.png'
import welcome3 from './img/welcome3.png'
import welcome4 from './img/welcome4.png'
import welcome5 from './img/welcome5.png'
import './styles.scss'

const onInit = () => {
  // Фикс бага с прокруткой страницы вниз при первом клике на слайд
  document.querySelectorAll('.slick-slide').forEach((it) => {
    it.removeAttribute('tabindex')
    it.querySelectorAll('.onboarding-slide, .settings-slide').forEach((it) => {
      it.removeAttribute('tabindex')
    })
  })
}

export const Screens = observer(() => {
  const ref = useRef<any>(null)
  const [currentSlide, setCurrentSlide] = useState(0)
  const store = useValueContext()
  const navigate = useNavigate()

  const { changeSettings, getBabies, createBaby } = store

  const nextToLastSlide = 5
  const isNextToLast = currentSlide === nextToLastSlide
  const isLast = currentSlide === 6

  const settings = {
    dots: true,
    infinite: false,
    accessibility: true,
    arrows: true,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    onInit,
    beforeChange: (currentIndex: number, nextIndex: number) => {
      analyticsContext.trackEvent(`next_${nextIndex + 1}_clicked`)

      if (currentIndex === nextToLastSlide && nextIndex < currentIndex) {
        setCurrentSlide(currentIndex - 1)
      } else if (currentIndex === 4 && nextIndex > currentIndex) {
        // На середине прокрутки устанавливаем индекс слайда,
        // чтобы избежать визуально резкого перекрытия футера слайдом
        setTimeout(() => {
          setCurrentSlide(currentIndex + 1)
        }, 200)
      } else {
        setCurrentSlide(nextIndex)
      }
    },
  }

  const onChangeSettings = (field: string) => (value: string | number) =>
    changeSettings(field, value)

  const onCreateBaby = async () => {
    const result = await createBaby()

    if (result) {
      getBabies()
      navigate('/home', { state: { showTooltips: true } })
    }
  }

  const onNext = () => (isLast ? onCreateBaby() : ref?.current?.slickNext())

  return (
    <div className="slider-container">
      <Slider
        className={cn({ 'settings-open': currentSlide >= nextToLastSlide })}
        ref={ref}
        {...settings}
      >
        <div className="onboarding-slide">
          <Tooltip
            content="Время с последнего кормления и сна
всегда под рукой"
            width={140}
            right={0}
            top={30}
            centered
            rounded
          />
          <Tooltip
            content="Быстрые кнопки для
записи кормления и сна"
            position="bottom-left"
            width={160}
            left={-25}
            top={185}
            centered
            rounded
          />
          <img src={welcome1} className="onboarding-img" alt="" />
        </div>
        <div className="onboarding-slide">
          <Tooltip
            content="Удобные графики для отслеживания режима малыша"
            position="bottom-right"
            width={200}
            right={25}
            top={250}
            centered
            rounded
          />
          <img src={welcome2} className="onboarding-img" alt="" />
        </div>
        <div className="onboarding-slide">
          <Tooltip
            content="Получайте напоминания в Telegram чате"
            width={190}
            right={15}
            top={210}
            centered
            rounded
          />
          <img src={welcome3} className="onboarding-img" alt="" />
        </div>
        <div className="onboarding-slide">
          <Tooltip
            content="Закрепите чат с ботом для быстрого доступа к приложению"
            position="top-right"
            width={190}
            right={-20}
            top={70}
            centered
            rounded
          />
          <img src={welcome4} className="onboarding-img" alt="" />
        </div>
        <div className="onboarding-slide">
          <Tooltip
            content="Добавьте приложение на экран Домой для быстрого доступа"
            position="bottom-left"
            width={190}
            right={-25}
            top={175}
            centered
            rounded
          />
          <img src={welcome5} className="onboarding-img" alt="" />
        </div>
        <div className="settings-slide">
          <Step1 onChange={onChangeSettings} enableTabIndex={isNextToLast} />
          <Link className="skip-link" onClick={() => ref?.current?.slickNext()}>
            Укажу позднее
          </Link>
        </div>
        <div className="settings-slide">
          <Step2 onChange={onChangeSettings} enableTabIndex={isLast} />
        </div>
      </Slider>

      <div className="slider-footer">
        <Button width={170} onClick={onNext} className="slider-next-button" uppercase>
          {isLast ? 'Готово' : 'Далее'}
        </Button>
        {!isLast && (
          <Link className="skip-link skip-all" onClick={onCreateBaby}>
            Пропустить
          </Link>
        )}
      </div>
    </div>
  )
})
